export default __webpack_public_path__ + "99e34992ffec458faf8fe8646cd71ca7.png";